import notifyHB from '@/config/notifyHB';
import { http } from '../http';

export async function cancelSigningRequest(docUlid: string, email: string) {
	try {
		const response = await http.delete<{
			code: string;
			message: string;
		}>(`documents/${docUlid}/signing-requests?email=${encodeURIComponent(email)}`);
		return response;
	} catch (exception) {
		notifyHB(
			'use-case',
			'cancelSigningRequest',
			`Failed to cancel signing request with ${exception}`,
		);
		throw exception;
	}
}
